import React from "react";
import { useContextLoaderHook } from "./loader-hooks";

type Loader = ReturnType<typeof useContextLoaderHook>;
export const LoaderContext = React.createContext<Loader | null>(null);

export function useContextLoader() {
  const context = React.useContext(LoaderContext);

  if (!context) {
    throw new Error("useLoader must be used within a LoaderProvider");
  }

  return context;
}
